/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useLogoutMutation } from 'api/authAPI';
import { logoutReducer } from 'features/auth/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import { loadState, removeState, saveState } from 'utils';
import moment from 'moment';
import { showAlert } from 'features/modal/modal';
import { setLoading } from 'features/loading';

function SessionTimeOut() {
	const STORAGE_KEY = 'cayesh_user_loggged';
	const dispatch = useDispatch();
	const { isAuthenticated } = useSelector(state => state.auth);
	const timeout = 1000 * 100 * 60; // 10 minutes

	const [remaining, setRemaining] = useState(timeout);
	const [elapsed, setElapsed] = useState(0);
	const [lastActive, setLastActive] = useState(+new Date());
	const [isIdle, setIsIdle] = useState(false);

	const handleOnActive = () => setIsIdle(false);

	const [logout] = useLogoutMutation();

	const handleOnIdle = () => {
		if (isAuthenticated) {
			dispatch(
				showAlert({
					title: 'Session Timeout',
					content: 'Your session has expired. you will be redirected to the login page',
					type: 'error',
					showCancel: false,
					confirmBtnText: 'Ok',
					closeOnClickOutside: false,
					closeOnClickEscape: false,
					onConfirm: () => {
						dispatch(setLoading(true));
						logout();
					}
				})
			);
			dispatch(logoutReducer());
		}
	};
	const { reset, pause, resume, getRemainingTime, getLastActiveTime } = useIdleTimer({
		timeout,
		onIdle: handleOnIdle
	});

	const handleReset = () => reset();
	const handlePause = () => pause();
	const handleResume = () => resume();

	useEffect(() => {
		const curentState = loadState(STORAGE_KEY);
		if (isAuthenticated) {
			if (moment().diff(moment(curentState?.lastActive), 'milliseconds') >= timeout) {
				handleOnIdle(); // Force logout if idle
			} else {
				saveState(
					{
						...curentState,
						lastActive: getLastActiveTime()
					},
					STORAGE_KEY
				);
			}
		}
	}, [lastActive]);

	useEffect(() => {
		setRemaining(getRemainingTime());
		setLastActive(getLastActiveTime());

		const expirationTimeout = setTimeout(() => {
			handleOnIdle(); // Trigger logout when the timeout is reached
		}, timeout);

		return () => clearTimeout(expirationTimeout); // Cleanup the timeout on component unmount
	}, []);

	return (
		<>
			{/* <div>
				<h1>Timeout: {timeout}ms</h1>
				<h1>Time Remaining: {remaining}</h1>
				<h1>Time Elapsed: {elapsed}</h1>

				<h1>Idle: {isIdle.toString()}</h1>
			</div>
			<div>
				<button onClick={handleReset}>RESET</button>
				<button onClick={handlePause}>PAUSE</button>
				<button onClick={handleResume}>RESUME</button>
			</div> */}
		</>
	);
}

export default SessionTimeOut;
